import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=dd89606a"
import script from "./UserItem.vue?vue&type=script&lang=js"
export * from "./UserItem.vue?vue&type=script&lang=js"
import style0 from "./UserItem.vue?vue&type=style&index=0&id=dd89606a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports